import { apiSlice } from "redux/Api.Slice";
import * as URL from "api/api/apiUrls";
const postConfig = {
  query: (body) => ({
    method: "POST",
    body: body,
  }),
  transformResponse: (response) => {
    return response;
  },
};

const SliderService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendOrderToSlider: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.SLIDER_CREATE_DELIVERY,
        ...postConfig.query(body),
      }),
    }),
    trackSliderOrder: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.SLIDER_GET_DELIVERY_STATUS,
        ...postConfig.query(body),
      }),
    }),
    cancelSliderOrder: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.SLIDER_CANCEL_DELIVERY,
        ...postConfig.query(body),
      }),
    }),
  }),
});
export const {
  useSendOrderToSliderMutation,
  useTrackSliderOrderMutation,
  useCancelSliderOrderMutation,
} = SliderService;
export default SliderService;
